import React, { useState, useEffect,useContext, useMemo  } from "react";
import { Link } from "react-router-dom";
import { useCart } from "./CartContext";
import Modal from "react-modal";
import { AuthContext } from "../login/AuthContext";
import FullCardGrid from "../GridViewMain/FullCardGrid/FullCardGrid";
import axios from "axios";
import { toast } from 'react-toastify';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';
import SendIcon from '../../utils/icon/SendIcon.js';
 import TrashCan from '../../utils/icon/TrashCan.js';
 import AddIcon from '../../utils/icon/AddIcon.js';
 import SeoHelmet from '../../Seo/SeoHelmet';
 import "../../styles/pages/cart-modern.scss"
 import { useSport } from '../../utils/SportsProvider';
Modal.setAppElement("#root");
const CartPage = () => {
  const {
    cart,
    addAdditionalItems,
    removeItem,
    removeAllItemsBySeller,
    checkout,
  } = useCart();

  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.CartPage[key][currentLang]; // Adjust the path according to your JSON structure
  const [offerValues, setOfferValues] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [thisUserCards, setThisUserCards] = useState([]);
  const [addedCards, setAddedCards] = useState([]);
  const [comment, setComment] = useState("");
  const [groupOfferValue, setGroupOfferValue] = useState({});
  const [shippingCosts, setShippingCosts] = useState({}); // Per sellerId
  const [modalSellerId, setModalSellerId] = useState(null);
  
  const [isMobile, setIsMobile] = useState(false);
  const localizedPath = (path) => {
  return currentLang === 'fr' ? `/fr${path}` : path;
};
const { state } = useSport();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const { userId,userName,liveCsrfToken} = useContext(AuthContext);
  console.log('here is the cart ',cart)
  const fetchCardData = async (SellerId) => {
    try {
      const sport = state?.sport || "Hockey";
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/getUserCards/${SellerId}?sport=${encodeURIComponent(sport)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const json = await res.json();
      setThisUserCards(json); // Update the thisUserCards state with fresh data
      console.log("Fetched cards:", json);
    } catch (error) {
      console.log("Error fetching card data:", error);
    }
  };



  // Effect to add additional cards when addedCards changes
  useEffect(() => {
    if (addedCards.length > 0) {
      addAdditionalItems(addedCards);
      setAddedCards([]); // Reset addedCards after adding to cart
      closeModal(); // Close the modal after adding items
    }
  }, [addedCards, addAdditionalItems]);

  // Open modal
  const openModal = (sellerId) => {
    fetchCardData(sellerId);
    setModalSellerId(sellerId);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // // Group items by seller
  // const groupedItems = cart.reduce((acc, item) => {
  //   if (!acc[item.SellerId]) {
  //     acc[item.SellerId] = {
  //       sellerName: item.sellerName,
  //       items: [],
  //     };
  //   }
  //   acc[item.SellerId].items.push(item);
  //   return acc;
  // }, {});

  const groupedItems = useMemo(() => {
    return cart.reduce((acc, item) => {
      if (!acc[item.SellerId]) {
        acc[item.SellerId] = {
          sellerName: item.sellerName,
          items: [],
        };
      }
      acc[item.SellerId].items.push(item);
      return acc;
    }, {});
  }, [cart]);


  const calculateTotal = (items) =>
    items.reduce((total, item) => total + (item.Price >0? item.Price:item.InitialPrice), 0);

 
useEffect(() => {
  // Build initial offer map from items that already have an offer different from InitialPrice
  const initialOffers = {};
  Object.values(groupedItems).forEach(({ items }) => {
    items.forEach((item) => {
      const hasPriorOffer =
        typeof item.Price === "number" &&
        typeof item.InitialPrice === "number" &&
        item.Price !== item.InitialPrice;

      if (hasPriorOffer) {
        // Seed with the prior offer (keep 2 decimals for display)
        initialOffers[item.userCardId] = Number(item.Price).toFixed(2);
      }
    });
  });

  // Merge—don’t clobber anything the user may already have typed
  if (Object.keys(initialOffers).length > 0) {
    setOfferValues((prev) => ({ ...initialOffers, ...prev }));
  }
}, [groupedItems]);



  const ApplyPatch = (label) => {
    if (!label) return null; // Guard against undefined
    const parts = label.split(" - ");
    if (parts.length > 4) {
      const patches = parts.slice(4);
      return (
        <div className="cart-isfor flex-h">
          
          {patches.map((patch, index) => (
            <div key={index} className="pill">
              {patch}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const extractUserCardIds = (items) => {
    return items.map(item => item.userCardId);
  };

  function sendOffer(Single,BuyerId, SellerId, isAnOffer, userCardId, price) {
    
       // Log the data
       console.log('BuyerId, SellerId, isAnOffer, userCardId, price',BuyerId, SellerId, isAnOffer, userCardId, price)
    if (userCardId != null > 0 && userCardId != SellerId) {

      console.log('BuyerId, SellerId, isAnOffer, userCardId, price, comment',BuyerId, SellerId, isAnOffer, userCardId, price, comment)
      submitOffer(parseInt(BuyerId), parseInt(SellerId), isAnOffer, userCardId, parseInt(price), comment);
      console.log("Offer Send");
    } else console.log("Trade is not completed.");
  }

  async function submitOffer(
    BuyerId,
    SellerId,
    isAnOffer,
    userCardId,
    price,
    comments,
  ) {
    let userCardArray = userCardId;
    if (!Array.isArray(userCardId)) {
      userCardArray = [userCardId];
    }
  
    console.log("Submitting trade offer for card(s):", userCardId);
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/submitOffer`,
        {
          BuyerId: BuyerId,
          SellerId: SellerId,
          isAnOffer: isAnOffer,
          userCardId: userCardArray,
          comments: comments,
          price: price,
          shipping: 0,
          userId: userId // Add userId to the body
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-csrf-token": liveCsrfToken, // Include CSRF token
          },
          withCredentials: true, // Ensure session cookies are sent
        }
      );
  
      // Handle the response from the server
      console.log("Trade Offer Submitted:", response.data);
      toast.success(t('Offer submitted successfully')); // Show success toast
  
      // You can perform additional actions based on the response if needed
      // resetAll();
    } catch (error) {
      console.error("Error submitting trade offer:", error);
      toast.error(t('Failed to submit offer')); // Show error toast
    }
  }


  // Function to handle changes in the textarea
  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  // const handleSingleOfferValueChange =(event) => {
  //   setSingleOfferValue(event.target.value);
  // };
  const handleOfferValueChange = (userCardId, listedPrice, value) => {
    let sanitizedValue = value.replace(',', '.'); // Convert commas to dots
  
    // Allow empty input (so user can type)
    if (sanitizedValue === "" || sanitizedValue === ".") {
      setOfferValues((prev) => ({ ...prev, [userCardId]: sanitizedValue }));
      return;
    }
  
    // Allow only numbers and one dot
    if (!/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
      return; // Prevent invalid input
    }
  
    // Convert to number
    const numericValue = parseFloat(sanitizedValue);
  
    if (isNaN(numericValue)) {
      toast.error("Offer price must be a valid number.");
      return;
    }
  
    if (numericValue > listedPrice && listedPrice!==0) {
      toast.error("Offer price must be lower than the listed price.");
      return;
    }
  
    // Store the value, but round to 2 decimal places if the user stops typing
    setOfferValues((prev) => ({
      ...prev,
      [userCardId]: sanitizedValue,
    }));
  };
  
  // OnBlur Event (Triggers when user clicks away)
  const handleOfferBlur = (userCardId, value) => {
    if (value !== "" && !isNaN(value)) {
      setOfferValues((prev) => ({
        ...prev,
        [userCardId]: parseFloat(value).toFixed(2), // Ensure 2 decimal places
      }));
    }
  };
  
  
 // Update shipping costs when totals or offers change
//  useEffect(() => {
//   const updatedShippingCosts = {};

//   Object.entries(groupedItems).forEach(([sellerId, { items }]) => {
//     const total = calculateTotal(items) + (groupOfferValue[sellerId] || 0);
//     const selectedPreference = items[0]; // Assume first item has the shipping preferences (minor, medium, big)

//     let shipping = 0;
//     if (selectedPreference) {
//       if (total <= 25) {
//         shipping = selectedPreference.minorCardShipping || 0;
//       } else if (total <= 75) {
//         shipping = selectedPreference.mediumCardShipping || 0;
//       } else {
//         shipping = selectedPreference.bigCardShipping || 0;
//       }
//     }
//     updatedShippingCosts[sellerId] = shipping;
//   });

//   setShippingCosts(updatedShippingCosts);
// }, [groupOfferValue, groupedItems]);

 // Update shipping costs when groupOfferValue or groupedItems change
 useEffect(() => {
  const updatedShippingCosts = {};
  
  Object.entries(groupedItems).forEach(([sellerId, { items }]) => {
    // Calculate the total price for all items for the seller
    const total = calculateTotal(items) + (groupOfferValue[sellerId] || 0);
    
    let shipping = 0;

    // Determine the appropriate shipping cost for the seller
    items.forEach((item) => {
      console.log('item',item)
      if (total <= 25) {
        shipping = Math.max(shipping, item.MinorCardShipping || 0);
      } else if (total <= 75) {
        shipping = Math.max(shipping, item.MediumCardShipping || 0);
      } else {
        shipping = Math.max(shipping, item.BigCardShipping || 0);
      }
      console.log('shipping',shipping,'total',total)
    });

    updatedShippingCosts[sellerId] = shipping;
  });

  setShippingCosts(updatedShippingCosts);
}, [groupOfferValue, groupedItems]);


const handleGroupOfferValueChange = (sellerId, value) => {
  setGroupOfferValue((prev) => ({
    ...prev,
    [sellerId]: parseFloat(value) || 0,
  }));
};

  const renderAttributeGrading = (GradingCompany, Grade, label) => {
    if (!GradingCompany) return null;

    console.log("GradingCompany, Grade, label", GradingCompany, Grade, label);
    const getGradingCompanyClass = (GradingCompany) => {
      switch (GradingCompany.toLowerCase()) {
        case "psa":
          return "psa";
        case "bgs":
          return "bgs";
        case "mnt":
          return "mnt";
        case "sgc":
          return "sgc";
        default:
          return ""; // Default class for unlisted grading companies
      }
    };

    return (
      <div class="line-item">
        
        <p class="planText">
          <button
            className={`patch-grading ${getGradingCompanyClass(
              GradingCompany
            )}`}
          >
            {`${GradingCompany} ${Grade}`}
          </button>
        </p>
      </div>
    );
  };
return (
  <section className="grid">
    <SeoHelmet type="cart" />

    <div className="cart-container">
      <h1>{t("Your Cart")}</h1>

      <div className="cart-table-container">
        {Object.keys(groupedItems).length === 0 && (
          <div className="empty-cart-message">
            <p
              style={{
                textAlign: "center",
                fontSize: "1.2rem",
                margin: "2rem 0",
                color: "#ccc",
              }}
            >
              {t("Your cart is empty")}
            </p>
          </div>
        )}

        {Object.entries(groupedItems).map(([sellerId, { sellerName, items }]) => (
          <React.Fragment key={sellerId}>
            <h2>
              {t("From the seller")}
              <Link
                to={localizedPath(`/ViewUserProfil/${sellerName}`)}
                className="seller-title"
              >
                {sellerName}
              </Link>
            </h2>

            {isMobile ? (
              <div className="cart-seller-mobile">
                {items.map((item) => (
                  <article key={item.userCardId} className="cart-mobile-card">
                    <button
                      type="button"
                      className="cart-mobile-removeIcon"
                      onClick={() => removeItem(item.userCardId)}
                      aria-label={t("Remove")}
                    >
                      <TrashCan size={20} />
                    </button>

                    <div className="cart-mobile-top">
                      <div className="cart-mobile-images">
                        <img
                          src={
                            item.ImageFront ||
                            require("../../assets/istockphotoImageComingSoon.jpg")
                          }
                          alt={item.title || "Card front"}
                          className="imgCart"
                        />
                        <img
                          src={
                            item.ImageUserBack ||
                            require("../../assets/istockphotoImageComingSoon.jpg")
                          }
                          alt={`${item.title || "Card"} back`}
                          className="imgCart"
                        />
                      </div>

                      <div className="cart-mobile-info">
                        <Link
                          to={localizedPath(`/cards/${item.userCardId}`)}
                          className="card-link-title cart-mobile-title"
                        >
                          {item.title
                            ? item.title.split(" - ").slice(0, 4).join(" - ")
                            : "No Title"}
                        </Link>

                        <div className="Cartcardisfor">{ApplyPatch(item.title)}</div>

                        <div className="cart-mobile-meta">
                          <span className="price-chip">
                            ${Number(item.InitialPrice || 0).toFixed(2)}
                          </span>

                          {item.Graded === 0 || item.Graded === false ? (
                            <span className="cart-mobile-condition">
                              {item.ConditionCard}
                            </span>
                          ) : (
                            renderAttributeGrading(item.GradeCompany, item.Grade)
                          )}
                        </div>

                        <div className="cart-mobile-actionRow">
                          <input
                            type="number"
                            className="cart-offer-input cart-mobile-offerInput"
                            value={offerValues[item.userCardId] ?? ""}
                            onChange={(e) =>
                              handleOfferValueChange(
                                item.userCardId,
                                item.InitialPrice,
                                e.target.value
                              )
                            }
                            onBlur={(e) =>
                              handleOfferBlur(item.userCardId, e.target.value)
                            }
                            placeholder={t("Offer")}
                            step="0.01"
                            min="0"
                          />

                          <button
                            className="send-offer-button cart-mobile-sendBtn"
                            onClick={() =>
                              sendOffer(
                                true,
                                userId,
                                sellerId,
                                true,
                                item.userCardId,
                                offerValues[item.userCardId] || 0
                              )
                            }
                          >
                            {t("Send Offer")} <SendIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                ))}

                <div className="cart-mobile-tools">
                  <button onClick={() => openModal(sellerId)} className="btn-utility">
                    {t("Add more cards/items to this offer")} <AddIcon size={24} />
                  </button>

                  <button
                    onClick={() => removeAllItemsBySeller(sellerId)}
                    className="btn-utility"
                  >
                    {t("Remove all cards/items from this seller")}{" "}
                    <TrashCan size={24} />
                  </button>

                  <div className="cart-mobile-bulkOffer">
                    <input
                      type="number"
                      value={groupOfferValue[sellerId] || ""}
                      className="cart-offer-input"
                      placeholder={t("Offer for all the items/cards")}
                      onChange={(e) =>
                        handleGroupOfferValueChange(sellerId, e.target.value)
                      }
                    />

                    <button
                      className="send-offer-button cart-mobile-sendBtn"
                      onClick={() =>
                        sendOffer(
                          false,
                          userId,
                          sellerId,
                          true,
                          extractUserCardIds(items),
                          groupOfferValue[sellerId]
                        )
                      }
                    >
                      {t("Send Offer")} <SendIcon />
                    </button>
                  </div>
                </div>

                <div className="checkout-container">
                  <div className="left-section-checkout">
                    <div className="row">
                      <label
                        htmlFor={`comment-mobile-${sellerId}`}
                        className="comment-label"
                      >
                        {t("Your Comment")}
                      </label>
                    </div>

                    <div className="row">
                      <textarea
                        id={`comment-mobile-${sellerId}`}
                        value={comment}
                        onChange={handleCommentChange}
                        rows="5"
                        className="comment-textarea"
                        placeholder={t("Type your comment here...")}
                      />
                    </div>
                  </div>

                  <div className="cart-summary">
                    <div className="summary-pill">
                      <span className="summary-label">{t("Shipping ($)")}</span>
                      <span className="summary-value">
                        ${Number(shippingCosts[sellerId] ?? 0).toFixed(2)}
                      </span>
                    </div>

                    <div className="summary-pill is-total">
                      <span className="summary-label">{t("Totals")}</span>
                      <span className="summary-value">
                        ${Number(
                          calculateTotal(items) + (shippingCosts[sellerId] ?? 0)
                        ).toFixed(2)}
                      </span>
                    </div>

                    <button
                      type="button"
                      onClick={() => checkout(sellerId)}
                      className="btn-checkout"
                      aria-label={t("Checkout")}
                    >
                      {t("Checkout")} <SendIcon />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>{t("Picture Front")}</th>
                    <th>{t("Picture Back")}</th>
                    <th>{t("Title")}</th>
                    <th>{t("Condition")}</th>
                    <th>{t("Listing Price")}</th>
                    <th>{t("Offer")}</th>
                    <th>{t("Send Offer")}</th>
                    <th>{t("Remove")}</th>
                  </tr>
                </thead>

                <tbody>
                  {items.map((item) => (
                    <tr key={item.userCardId}>
                      <td data-label={"Picture Front"}>
                        <img
                          src={
                            item.ImageFront ||
                            require("../../assets/istockphotoImageComingSoon.jpg")
                          }
                          alt={item.title}
                          className="imgCart"
                        />
                      </td>

                      <td data-label={"Picture Back"}>
                        <img
                          src={
                            item.ImageUserBack ||
                            require("../../assets/istockphotoImageComingSoon.jpg")
                          }
                          alt={item.title}
                          className="imgCart"
                        />
                      </td>

                      <td data-label={"Title"}>
                        <div>
                          <Link
                            to={localizedPath(`/cards/${item.userCardId}`)}
                            className="card-link-title"
                          >
                            {item.title
                              ? item.title.split(" - ").slice(0, 4).join(" - ")
                              : "No Title"}
                          </Link>
                        </div>

                        <div className="Cartcardisfor">{ApplyPatch(item.title)}</div>
                      </td>

                      <td data-label={"Condition"}>
                        {item.Graded === 0 || item.Graded === false ? (
                          <p>{item.ConditionCard}</p>
                        ) : (
                          renderAttributeGrading(item.GradeCompany, item.Grade)
                        )}
                      </td>

                      <td data-label={"Listing Price"}>
                        <span className="price-chip">
                          {`$${Number(item.InitialPrice || 0).toFixed(0)}`}
                        </span>
                      </td>

                      <td data-label={"Offer"}>
                        <input
                          type="number"
                          className="offer-input"
                          value={offerValues[item.userCardId] ?? ""}
                          onChange={(e) =>
                            handleOfferValueChange(
                              item.userCardId,
                              item.InitialPrice,
                              e.target.value
                            )
                          }
                          onBlur={(e) =>
                            handleOfferBlur(item.userCardId, e.target.value)
                          }
                          step="0.01"
                          min="0"
                        />
                      </td>

                      <td data-label={"Send Offer"}>
                        <button
                          onClick={() =>
                            sendOffer(
                              true,
                              userId,
                              sellerId,
                              true,
                              item.userCardId,
                              offerValues[item.userCardId] || 0
                            )
                          }
                          className="send-offer-button"
                        >
                          {t("Send Offer")} <SendIcon />
                        </button>
                      </td>

                      <td data-label={"Remove"}>
                        <button
                          onClick={() => removeItem(item.userCardId)}
                          className="send-offer-button is-ghost"
                        >
                          {t("Remove")} <TrashCan size={30} />
                        </button>
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td colSpan="8">
                      <div className="cart-page">
                        <div className="cart-table-container">
                          <div className="cart-offer-tools">
                            <div className="cart-toolbar">
                              <button
                                onClick={() => openModal(sellerId)}
                                className="btn-utility"
                              >
                                {t("Add more cards/items to this offer")}{" "}
                                <AddIcon size={30} />
                              </button>

                              <button
                                onClick={() => removeAllItemsBySeller(sellerId)}
                                className="btn-utility"
                              >
                                {t("Remove all cards/items from this seller")}{" "}
                                <TrashCan size={30} />
                              </button>
                            </div>

                            <div className="cart-offer-group">
                              <label>{t("Offer for all the items/cards")}</label>
                              <input
                                type="number"
                                value={groupOfferValue[sellerId] || ""}
                                className="cart-offer-input"
                                onChange={(e) =>
                                  handleGroupOfferValueChange(
                                    sellerId,
                                    e.target.value
                                  )
                                }
                              />
                              <button
                                className="send-offer-button"
                                onClick={() =>
                                  sendOffer(
                                    false,
                                    userId,
                                    sellerId,
                                    true,
                                    extractUserCardIds(items),
                                    groupOfferValue[sellerId]
                                  )
                                }
                              >
                                {t("Send Offer")} <SendIcon />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="8">
                      <div className="checkout-container">
                        <div className="left-section-checkout">
                          <div className="row">
                            <label
                              htmlFor={`comment-desktop-${sellerId}`}
                              className="comment-label"
                            >
                              {t("Your Comment")}
                            </label>
                          </div>

                          <div className="row">
                            <textarea
                              id={`comment-desktop-${sellerId}`}
                              value={comment}
                              onChange={handleCommentChange}
                              rows="5"
                              cols="50"
                              className="comment-textarea"
                              placeholder={t("Type your comment here...")}
                            />
                          </div>
                        </div>

                        <div className="cart-summary">
                          <div className="summary-pill">
                            <span className="summary-label">
                              {t("Shipping ($)")}
                            </span>
                            <span className="summary-value">
                              ${Number(shippingCosts[sellerId] ?? 0).toFixed(2)}
                            </span>
                          </div>

                          <div className="summary-pill is-total">
                            <span className="summary-label">{t("Totals")}</span>
                            <span className="summary-value">
                              ${Number(
                                calculateTotal(items) +
                                  (shippingCosts[sellerId] ?? 0)
                              ).toFixed(2)}
                            </span>
                          </div>

                          <button
                            type="button"
                            onClick={() => checkout(sellerId)}
                            className="btn-checkout"
                            aria-label={t("Checkout")}
                          >
                            {t("Checkout")} <SendIcon />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>

    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        content: {
          width: "100%",
          margin: "auto",
          marginTop: "50px",
          background: "black",
          height: "90%",
          inset: "0",
          position: "relative",
          padding: "0px",
        },
      }}
    >
      {thisUserCards.length > 0 ? (
        <>
          <button
            className="btn-baseBlue"
            onClick={() => closeModal()}
            style={{ marginBottom: "1rem" }}
          >
            {t("Go Back")}
          </button>

          <section className="grid">
            <div className="contentfront">
              <FullCardGrid
                setCards={setThisUserCards}
                cards={thisUserCards}
                groupedCards={[]}
                viewAsGrid={false}
                viewOnly={true}
                cardGridType={"CardGridSell"}
                MultiCardOfferSelection={true}
                SetMultiCardOfferSelection={setAddedCards}
                preSelectedCards={extractUserCardIds(
                  groupedItems[modalSellerId]?.items || []
                )}
                setModal={() => console.log("")}
              />
            </div>
          </section>
        </>
      ) : (
        <h3>{t("This Seller's Item(s) are loading...")}</h3>
      )}
    </Modal>
  </section>
);
};

export default CartPage;
